export default __webpack_public_path__ + "static/media/PROCESS_STEP1_XS.27a735a2.png";